// 電腦 左右拖移選項
import { useRef } from 'react';
function useDragScroll() {
  const ref = useRef(null);

  const handleMouseDown = (e) => {
    const container = ref.current;

    if (!container) return;

    container.isDown = true;
    container.startX = e.pageX - container.offsetLeft;
    container.scrollLeftStart = container.scrollLeft;

    container.classList.add('is-dragging');
  };

  const handleMouseMove = (e) => {
    const container = ref.current;

    if (!container?.isDown) return;

    e.preventDefault();

    const x = e.pageX - container.offsetLeft;
    const walk = x - container.startX;

    container.scrollLeft = container.scrollLeftStart - walk;
  };

  const handleMouseUp = () => {
    const container = ref.current;

    if (!container) return;

    container.isDown = false;
    container.classList.remove('is-dragging');
  };

  return {
    ref,
    dragEvents: {
      onMouseDown: handleMouseDown,
      onMouseMove: handleMouseMove,
      onMouseUp: handleMouseUp,
      onMouseLeave: handleMouseUp,
    },
  };
}

export default useDragScroll;
